import { isOpenerVariant, type AnimationVariant, type PreviewCommand } from '@game-platform/pack-animation';

// Same control style as the theme editor's top bar (h-7, font-mono 11px)
export const TOP_BUTTON =
  'h-7 rounded border border-neutral-700 bg-neutral-900 px-3 font-mono text-[11px] text-white outline-none hover:bg-neutral-800 disabled:cursor-not-allowed disabled:opacity-40';

interface Props {
  variant: AnimationVariant;
  hasOptions: boolean;
  onCommand: (command: PreviewCommand) => void;
  onResetPreview: () => void;
  onResetOptions: () => void;
}

/** Drive the preview scene and drop tuned knobs; dark, for a bar over the preview. */
export function PreviewCommands({ variant, hasOptions, onCommand, onResetPreview, onResetOptions }: Props) {
  return (
    <>
      <button
        type="button"
        className={TOP_BUTTON}
        disabled={!isOpenerVariant(variant)}
        onClick={() => onCommand('play')}
      >
        Play
      </button>
      {variant === 'carousel' && (
        <button type="button" className={TOP_BUTTON} onClick={() => onCommand('shuffle')}>
          Shuffle
        </button>
      )}
      <button type="button" className={TOP_BUTTON} onClick={onResetPreview}>
        Reset preview
      </button>
      <button type="button" className={TOP_BUTTON} disabled={!hasOptions} onClick={onResetOptions}>
        Reset to preset
      </button>
    </>
  );
}
